module.exports = __webpack_public_path__ + "img/radio.a5c5d26b.svg";